import { React, useEffect } from "react";
import "animate.css";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";

import CloseIcon from "@mui/icons-material/Close";

export default function TransitionAlerts({ openAlert, text, onClose }) {
	//const [open, setOpen] = useState(openAlert);
	useEffect(() => {
		if (!openAlert) return; // only set timer if alert is open

		const timeId = setTimeout(() => {
			onClose(); // call the function to close
		}, 3000);

		return () => {
			clearTimeout(timeId);
		};
	}, [openAlert, onClose]);
	return (
		<Box sx={{ width: "100%" }}>
			<Collapse in={openAlert}>
				<Alert
					action={
						<IconButton
							aria-label="close"
							color="inherit"
							size="small"
							onClick={onClose}
						>
							<CloseIcon fontSize="inherit" />
						</IconButton>
					}
					sx={{ mb: 2 }}
				>
					{text}
				</Alert>
			</Collapse>
		</Box>
	);
}
